import React from 'react';
import { NamedRedirect } from '../../components';

const EmilyPage = () => {
  return (
    <NamedRedirect name="ProfilePage" params={{ id: '622e59d9-8f73-45e1-95d9-886db71ecc80' }} />
  );
};

export default EmilyPage;
